<template>
  <div
    v-if="flash && (flash.success || flash.error)"
    class="alert alert-dismissible fade show"
    role="alert"
    :class="{
      'alert-success': flash.success,
      'alert-danger': flash.error,
    }"
  >
    {{ flash.success || flash.error }}
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    flash: Object,
  },
  data() {},
  methods: {},
};
</script>